import { httpClient } from "./BaseApi";

const NEWS_LIST_URL = "api/company/news/list.json";

const NewsApi = {
  getList: (params = { limit: 5 }) => httpClient.get(NEWS_LIST_URL, { params }),
};

export default NewsApi;
